import type { IStockListingRow } from '../interfaces/StockListingTable.interface';

/**
 * Formats a price value with a "+" prefix if positive
 * @param value - The price value as a string
 * @param isPositive - Whether the value is positive
 * @returns Formatted price string with appropriate prefix
 */
export const formatPriceLabel = (value: string | number, isPositive: boolean): string => {
  const str = String(value).trim();
  if (!str) {
    return str;
  }

  const normalizedValue = str.replace(/^[+-]/, "");

  if (isPositive) {
    return str.startsWith("+") ? str : `+${normalizedValue}`;
  }

  return str.startsWith("-") ? str : `-${normalizedValue}`;
};

/**
 * Formats price change information for display
 * @param item - Stock listing row item
 * @param isSkeleton - Whether this is a skeleton/loading state
 * @returns Formatted price change string (e.g., "+0.00 (0.00%)")
 */
export const formatPriceChange = (item: IStockListingRow, isSkeleton: boolean): string => {
  if (isSkeleton) {
    return "+0.00 (0.00%)";
  }
  const isPositive = Number(item.perChange) >= 0;
  const changePrice = String(item.changePrice ?? "");
  const perChange = String(item.perChange ?? "");
  return `${formatPriceLabel(changePrice, isPositive)} (${formatPriceLabel(perChange, isPositive)}%)`;
};

